import { getScenarioSceneButtons } from "./scenarioScenes";

export function getButtonDeletionInfo(buttonId, nodes = [], edges = []) {
  const normalizedButtonId = String(buttonId);
  const outgoingEdge = edges.find(
    (edge) => String(edge.source) === normalizedButtonId,
  );
  const targetScene = outgoingEdge
    ? nodes.find((node) => String(node.id) === String(outgoingEdge.target))
    : null;
  const targetSceneId = targetScene ? String(targetScene.id) : null;
  const hasOtherIncomingButtons = targetSceneId
    ? edges.some((edge) => {
        if (
          String(edge.target) !== targetSceneId ||
          String(edge.source) === normalizedButtonId
        ) {
          return false;
        }
        return nodes.some(
          (node) => String(node.id) === String(edge.source) && node.type === "input",
        );
      })
    : false;
  const sceneButtons = targetScene
    ? getScenarioSceneButtons(targetScene, nodes, edges)
    : [];

  return {
    buttonId,
    isLinked: Boolean(targetScene),
    targetScene,
    targetSceneId: targetScene?.id ?? null,
    targetSceneLabel: targetScene?.data?.label ?? "Сцена",
    hasOtherIncomingButtons,
    canDeleteScene:
      Boolean(targetScene) &&
      String(targetScene.id) !== "1" &&
      !hasOtherIncomingButtons,
    hasChildButtons: sceneButtons.length > 0,
  };
}

export function removeScenarioButton(
  buttonId,
  nodes = [],
  edges = [],
  deleteTargetScene = false,
) {
  const deletionInfo = getButtonDeletionInfo(buttonId, nodes, edges);
  const removedNodeIds = new Set([String(buttonId)]);

  if (deleteTargetScene && deletionInfo.canDeleteScene) {
    const sceneId = String(deletionInfo.targetScene.id);
    const groupId = String(
      deletionInfo.targetScene.parentId ??
        deletionInfo.targetScene.parentNode ??
        `${sceneId}-group`,
    );

    removedNodeIds.add(sceneId);
    removedNodeIds.add(groupId);
    getScenarioSceneButtons(deletionInfo.targetScene, nodes, edges).forEach(
      (button) => removedNodeIds.add(String(button.buttonId)),
    );
  }

  return {
    nodes: nodes.filter((node) => !removedNodeIds.has(String(node.id))),
    edges: edges.filter(
      (edge) =>
        !removedNodeIds.has(String(edge.source)) &&
        !removedNodeIds.has(String(edge.target)),
    ),
  };
}
